import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LegalAgreementsContact from '@/components/legal/LegalAgreementsContact';

const TermsOfUse = () => {
  const { t } = useTranslation();
  const [, setActiveSection] = useState(null);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  const tableOfContents = Array.from({ length: 40 }, (_, i) => ({
    id: `section-${i + 1}`,
    title: t(`termOfUse_toc${i + 1}`),
  }));

  return (
    <div className="min-h-screen bg-home">
      {/* Header */}
      <header className="bg-darkBlue text-white">
        <div className="max-w-4xl mx-auto px-4 pt-28 pb-12 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
              {t('termOfUse_pageTitle')}
            </h1>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        {/* Last Updated */}
        <div className="mb-8 p-4 bg-blue-50 border-l-4 border-indigo-500 rounded-r-lg">
          <p className="text-sm text-gray-600">
            <span className="font-semibold">{t('termOfUse_lastUpdatedLabel')}</span> {t('termOfUse_lastUpdatedText')}
          </p>
        </div>

        {/* Introduction */}
            <div className="mb-10 p-8 bg-gradient-to-r from-indigo-50 via-white to-purple-50 rounded-xl border border-indigo-100 shadow-sm">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="bg-darkBlue text-white px-3 py-1 rounded-full text-sm font-semibold">Intro</span>
                {t('termOfUse_introTitle')}
            </h2>

            <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                {t('termOfUse_intro1')}
                </p>

                <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4 rounded-md">
                <p>
                    {t('termOfUse_intro2').split('www.jandipr.com').map((part, i, arr) => (
                      i < arr.length - 1 ? (
                        <React.Fragment key={i}>
                          {part}
                          <a href="https://www.jandipr.com" target="_blank" rel="noopener noreferrer" className="text-indigo-700 font-medium underline hover:text-indigo-900">www.jandipr.com</a>
                        </React.Fragment>
                      ) : part
                    ))}
                </p>
                </div>

                <p>
                {t('termOfUse_intro3a')}
                <Link to="/politica-de-privacidad" className="text-darkBlue font-medium underline hover:text-indigo-800">
                    {t('termOfUse_intro3b')}
                </Link>
                {t('termOfUse_intro3c')}
                </p>
            </div>
            </div>



        {/* Table of Contents */}
        <div className="mb-12 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">{t('termOfUse_tocTitle')}</h2>
          </div>
          <div className="px-6 py-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {tableOfContents.map((item, index) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left p-2 text-darkBlue hover:text-indigo-800 hover:bg-indigo-50 rounded transition-colors duration-200"
                >
                  <span className="font-medium">{index + 1}.</span> {item.title}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-12">
          {Array.from({ length: 40 }, (_, i) => i + 1).map((n) => (
            <section key={n} id={`section-${n}`} className="scroll-mt-8">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-4 bg-indigo-50 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                    <span className="bg-darkBlue text-white px-3 py-1 rounded-full text-sm font-bold">{n}</span>
                    {t(`termOfUse_s${n}Title`)}
                  </h2>
                </div>
                <div className="px-6 py-6 space-y-4">
                  {t(`termOfUse_s${n}Body`).split(/\n\n/).map((para, i) => (
                    <p key={i} className="text-gray-700 leading-relaxed">{para}</p>
                  ))}
                </div>
              </div>
            </section>
          ))}

          <LegalAgreementsContact />
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;